<app-website-header></app-website-header>

<!-- Page Banner -->
<section class="page-banner">
    <div class="banner-content">
        <h1>About <span class="highlight">Aathreya Machine Tools</span></h1>
        <p>Your Trusted Partner in Tool Room Machineries Sales & Service</p>
    </div>
</section>

<!-- Welcome Section -->
<section class="welcome-section">
    <div class="section-container">
        <div class="welcome-grid">
            <div class="welcome-text">
                <span class="section-label"><i class="fas fa-building"></i> Welcome</span>
                <h2>Empowering Industries with <span class="highlight">Precision Machinery</span></h2>
                <p>
                    Aathreya Machine Tools (AMT) is a trusted name in the field of Tool Room Machineries
                    Sales & Service. With a strong commitment to quality, reliability, and customer
                    satisfaction, we deliver precision-driven machine solutions that empower industries
                    to perform at their best.
                </p>
                <p>
                    Founded with the vision of providing dependable machinery and technical service support,
                    we have steadily grown into a preferred partner for manufacturing industries across
                    Tamil Nadu and beyond.
                </p>
            </div>
            <div class="welcome-image">
                <div class="image-placeholder">
                    <i class="fas fa-industry"></i>
                    <span>Where You Can Trust</span>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Leadership Section -->
<section class="leadership-section">
    <div class="section-container">
        <div class="leader-card">
            <div class="leader-avatar">
                <i class="fas fa-user-tie"></i>
            </div>
            <div class="leader-info">
                <h3>Mr. M. Manikandan</h3>
                <span class="leader-title">Managing Director</span>
                <p>
                    Under his leadership, AMT has built a reputation for integrity, technical
                    excellence, and prompt service support. His industry knowledge and customer-focused
                    approach drive the company's success.
                </p>
            </div>
        </div>
    </div>
</section>

<!-- Services Section -->
<section class="services-section">
    <div class="section-container">
        <div class="section-header">
            <span class="section-label"><i class="fas fa-cogs"></i> What We Do</span>
            <h2>Our <span class="highlight">Specializations</span></h2>
        </div>
        <div class="services-grid">
            <div class="service-card" *ngFor="let service of services">
                <div class="service-icon">
                    <i [class]="service.icon"></i>
                </div>
                <h4>{{ service.title }}</h4>
            </div>
        </div>
    </div>
</section>

<!-- Expertise Section -->
<section class="expertise-section">
    <div class="section-container">
        <div class="expertise-grid">
            <div class="expertise-text">
                <span class="section-label"><i class="fas fa-chart-line"></i> Industries We Serve</span>
                <h2>Our <span class="highlight">Expertise</span></h2>
                <p>We cater to a wide range of industries, ensuring every machine we supply and service meets strict
                    performance and durability standards.</p>
                <ul class="expertise-list">
                    <li *ngFor="let item of expertise">
                        <i class="fas fa-check-circle"></i> {{ item }}
                    </li>
                </ul>
            </div>
            <div class="expertise-visual">
                <div class="expertise-stat">
                    <div class="stat-circle">
                        <span class="stat-num">500+</span>
                        <span class="stat-text">Machines Delivered</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Mission & Vision -->
<section class="mv-section">
    <div class="section-container">
        <div class="mv-grid">
            <div class="mv-card mission">
                <div class="mv-icon"><i class="fas fa-bullseye"></i></div>
                <h3>Our Mission</h3>
                <p>
                    To provide high-quality machine tools and dependable service support that enhance
                    productivity, precision, and profitability for our customers.
                </p>
            </div>
            <div class="mv-card vision">
                <div class="mv-icon"><i class="fas fa-eye"></i></div>
                <h3>Our Vision</h3>
                <p>
                    To become a leading and most trusted machinery solutions provider known for
                    excellence, innovation, and long-term customer relationships.
                </p>
            </div>
        </div>
    </div>
</section>

<!-- Commitment -->
<section class="commitment-section">
    <div class="section-container">
        <div class="commitment-content">
            <span class="section-label"><i class="fas fa-heart"></i> Our Commitment</span>
            <h2>We Understand That <span class="highlight">Downtime Costs You</span></h2>
            <p>
                At Aathreya Machine Tools, we understand that machine downtime directly impacts production.
                That is why we prioritize fast service response, skilled technical support, and dependable
                solutions to keep your operations running smoothly.
            </p>
            <div class="commitment-taglines">
                <div class="tagline">
                    <i class="fas fa-handshake"></i>
                    <span>Your trust is our strength.</span>
                </div>
                <div class="tagline">
                    <i class="fas fa-chart-line"></i>
                    <span>Your productivity is our priority.</span>
                </div>
            </div>
        </div>
    </div>
</section>

<app-website-footer></app-website-footer>